import { render, staticRenderFns } from "./chaternewptclass.vue?vue&type=template&id=1633ec1f&scoped=true"
import script from "./chaternewptclass.vue?vue&type=script&lang=js"
export * from "./chaternewptclass.vue?vue&type=script&lang=js"
import style0 from "./chaternewptclass.vue?vue&type=style&index=0&id=1633ec1f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1633ec1f",
  null
  
)

export default component.exports